import { render, staticRenderFns } from "./MyMarkBlock.vue?vue&type=template&id=c562e160&scoped=true&"
import script from "./MyMarkBlock.vue?vue&type=script&lang=js&"
export * from "./MyMarkBlock.vue?vue&type=script&lang=js&"
import style0 from "./MyMarkBlock.vue?vue&type=style&index=0&id=c562e160&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c562e160",
  null
  
)

export default component.exports